<template>
  <BaseCard title="Turnos" :noHover="true" :collapsible="true">
    <div class="scroll-container" v-if="turnos.length">
      <table class="turnos-table">
        <thead>
          <tr>
            <th>Fecha</th>
            <th>Hora</th>
            <th>Motivo</th>
            <th>Estado</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(t, i) in turnos" :key="i">
            <td class="col-fecha">{{ formatDate(t.fecha) }}</td>
            <td class="col-hora">{{ t.inicio || t.hora }}</td>
            <td>{{ t.motivo }}</td>
            <td>
              <span :class="['badge', (t.estado || 'pendiente').toLowerCase()]">{{ formatarEstado(t.estado) }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <p v-else class="empty-msg">No hay turnos registrados</p>

    <div class="footer-actions">
      <button class="btn-action" @click="$emit('agregar')">Agendar Turno</button>
    </div>
  </BaseCard>
</template>

<script setup>
import BaseCard from "./BaseCard.vue";

defineProps({
  turnos: {
    type: Array,
    default: () => []
  }
});

defineEmits(['agregar']);

function formatDate(dateStr) {
  if (!dateStr) return '-';
  const [year, month, day] = dateStr.split('-');
  const date = new Date(year, month - 1, day);
  return new Intl.DateTimeFormat('es-ES', { month: 'short', day: 'numeric', year: 'numeric' }).format(date);
}

function formatarEstado(estado) {
  if (!estado) return 'No Confirmado';
  
  const estados = {
    'pendiente': 'No Confirmado',
    'confirmado': 'Confirmado',
    'anulado': 'Anulado',
    'atendido': 'Atendido',
    'eliminada': 'Cita Eliminada',
    'no asiste': 'No Asiste'
  };
  
  return estados[estado.toLowerCase()] || estado;
}
</script>

<style scoped>
.turnos-table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
}

.turnos-table th {
  font-size: 13px;
  font-weight: 600;
  color: #64748b;
  padding: 8px 4px;
  border-bottom: 2px solid #f1f5f9;
}

.turnos-table td {
  font-size: 14px;
  padding: 12px 4px;
  border-bottom: 1px solid #f8fafc;
  color: #334155;
  vertical-align: top;
}

.turnos-table tr:last-child td {
  border-bottom: none;
}

.col-fecha {
  font-weight: 600;
  color: #111827;
  text-transform: capitalize;
  width: 30%;
}

.col-hora {
  font-weight: 500;
  width: 20%;
}

.scroll-container {
  max-height: 300px;
  overflow-y: auto;
  padding-right: 4px;
}

.footer-actions {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
}

.btn-action {
  background: #eaf1ff;
  color: #678AB2;
  border: none;
  padding: 6px 12px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  transition: background 0.2s;
}

.btn-action:hover {
  background: #dbeafe;
}

.empty-msg {
  color: #9ca3af;
  font-style: italic;
  text-align: center;
  margin: 16px 0;
}

/* Estilos específicos para mejorar el encabezado en la ficha */
:deep(.card) {
  padding: 0 !important;
  overflow: hidden;
}

:deep(.card-header) {
  background-color: #f8f9fa;
  padding: 16px;
  border-bottom: 1px solid #e5e7eb;
  margin-bottom: 0 !important;
}

:deep(.card-body) {
  padding: 16px;
}

.badge { padding: 2px 8px; border-radius: 12px; font-size: 11px; font-weight: 600; text-transform: uppercase; display: inline-block; }
.badge.pendiente { background: white; color: #374151; border: 1.5px solid #d1d5db; }
.badge.confirmado { background: #d1fae5; color: #065f46; }
.badge.anulado { background: #fee2e2; color: #991b1b; }
.badge.atendido { background: #e0e7ff; color: #3730a3; }
.badge.eliminada { background: #f3f4f6; color: #6b7280; text-decoration: line-through; }
.badge.no.asiste { background: #fef3c7; color: #92400e; }</style>
